import HomeView from '../views/HomeView.vue'
import AllEmployees from '../views/employees/AllEmployees.vue'
import EmployeeBee from '../views/employees/EmployeeBee.vue'
import TaskPapers from '../views/tasks/TaskPapers.vue'
import AddPaperTask from '../views/tasks/AddPaperTask.vue'
import TaskPaperInfo from '../views/tasks/TaskPaperInfo.vue'
import EmployeeProjectStatistics from '../views/statistics/EmployeeProjectStatistics.vue'
import ProjectStatistics from '../views/statistics/ProjectStatistics.vue'
import EmployeeOverviewStatistics from '../views/statistics/EmployeeOverviewStatistics.vue'
import Projects from '../views/projects/Projects.vue'
import TheOneProject from '../views/projects/TheOneProject.vue'
import ManageCategories from '../views/ManageCategories'
import TaskMatching from '../views/tasks/TaskMatching'
import TaskTabs from '../views/tasks/TaskTabs'
import Login from '@/views/Login.vue'
import Tags from '../views/Tags'
import AllTasks from '../views/userProfile/AllTasks'
import Task from '../views/userProfile/Task'
import WeeklyPlan from '../views/userProfile/WeeklyPlan'
import Statistics from '../views/userProfile/Statistics'
import Categories from '../views/projects/Categories'
import RolesAtTheProjectLevel from '../views/projects/RolesAtTheProjectLevel'
import ProjectTabs from '../views/projects/ProjectTabs'
import TasksManagement from '../views/tasks/TasksManagement'
import AddingDraft from '../views/plans/AddingDraft'
import PlanMatching from '../views/plans/PlanMatching'
import EmployeeLeaves from '../views/leaves/EmployeeLeaves'
import LeavesManagements from '../views/leaves/LeavesManagements'
import FeaturesPage from '@/views/features/FeaturesPage.vue'
import CategoriesStatistics from '@/views/statistics/CategoriesStatistics'
import ProjectStatistics2 from '@/views/statistics/ProjectStatistics2'

export default [
	{
		path: '/',
		name: 'home',
		component: HomeView,
		title: ''
	},
	{
		path: '/all-employees',
		name: 'all-employees',
		component: AllEmployees,
		meta: {
			title: 'All employee'
		}
	},
	{
		path: '/employee',
		name: 'employee-bee',
		component: EmployeeBee,
		meta: {
			title: 'Employee statistics'
		}
	},
	{
		path: '/add-papers/:id?',
		name: 'add-papper-task',
		component: AddPaperTask,
		meta: {
			title: 'Add paper Task'
		}
	},
	{
		path: '/add-papers',
		name: 'add-task',
		component: AddPaperTask,
		title: 'Add paper Task'
	},
	{
		path: '/task-paper-info/:id?',
		name: 'task-paper-info',
		component: TaskPaperInfo,
		meta: {
			title: ''
		}
	},
	{
		name: 'HomeView',
		path: '/',
		component: HomeView,
		meta: {
			title: ''
		}
	},
	{
		name: 'login',
		path: '/login',
		component: Login,
		meta: {
			title: ''
		}
	},
	{
		name: 'employee-project-statistics',
		path: '/employee-project',
		component: EmployeeProjectStatistics,
		meta: {
			title: 'Employee salary statistics'
		}
	},
	{
		name: 'project-statistics',
		path: '/project',
		component: ProjectStatistics,
		meta: {
			title: 'Project statistics'
		}
	},
	{
		name: 'one-project',
		path: '/project/:id?',
		component: TheOneProject,
		meta: {
			title: 'Projects'
		}
	},
	{
		name: 'employee-overview-statistics',
		path: '/employee-overview',
		component: EmployeeOverviewStatistics,
		meta: {
			title: ''
		}
	},
	{
		name: 'manage-categories',
		path: '/manage-categories',
		component: ManageCategories,
		meta: {
			title: ''
		}
	},
	{
		name: 'task-tabs',
		path: '/task-tabs',
		component: TaskTabs,
		children: [
		],
		meta: {
			title: ''
		}
	},
	{
		name: 'all-tasks',
		path: '/all-tasks/:id?',
		component: AllTasks,
		meta: {
			title: 'WorkDays'
		}
	},
	{
		name: 'tasks',
		path: '/tasks/:id?',
		component: Task,
		meta: {
			title: 'Add Task'
		}
	},
	{
		name: 'weekly-plan',
		path: '/weekly-plan/:id?',
		component: WeeklyPlan,
		meta: {
			title: 'Plan'
		}
	},
	{
		name: 'tags',
		path: '/tags',
		component: Tags,
		meta: {
			title: ''
		}
	},

	{
		name: 'statistics',
		path: '/statistics',
		component: Statistics,
		meta: {
			title: ''
		}
	},

	{
		name: 'project-tabs',
		path: '/projects-management',
		component: ProjectTabs,
		meta: {
			title: 'Projects management'
		},
		children: [
			{
				name: 'projects',
				path: '/projects-management/projects',
				component: Projects,
				meta: {
					title: 'Projects management'
				}
			}, 
			{
				name: 'categories',
				path: '/projects-management/categories',
				component: Categories,
				meta: {
					title: 'Projects management'
				}
			},
			{
				name: 'roles-at-project',
				path: '/projects-management/roles-at-project',
				component: RolesAtTheProjectLevel,
				meta: {
					title: 'Projects management'
				}
			}
		]
	},
	{
		name: 'tasks-management',
		path: '/tasks-management',
		component: TasksManagement,
		meta: {
			title: ''
		},
		children: [
			{
				name: 'task-papers',
				path: '/tasks-management/task-papers',
				component: TaskPapers,
				meta: {
					title: 'Task management'
				}
			},
			{
				name: 'task-matching',
				path: '/tasks-management/task-matching',
				component: TaskMatching,
				meta: {
					title: 'Task management'
				}
			}
		],
		title: ''
	},

	{
		name: 'plan-matching',
		path: '/plan-matching',
		component: PlanMatching,
		meta: {
			title: 'Plan Matching'
		}
	},

	{
		name: 'adding-draft',
		path: '/adding-draft',
		component: AddingDraft,
		meta: {
			title: 'Draft'
		}
	},
	{
		name: 'employee-leaves',
		path: '/employee-leaves',
		component: EmployeeLeaves,
		meta: {
			title: 'Leaves'
		}
	},
	{
		name: 'leaves-managements',
		path: '/leaves-managements',
		component: LeavesManagements,
		meta: {
			title: 'Leaves'
		}
	},
	{
		name: 'features-page',
		path: '/features-page/:id?',
		component: FeaturesPage,
		meta: {
			title: 'Features'
		}
	},
	{
		name: 'categories-statistics',
		path: '/categories-statistics',
		component: CategoriesStatistics,
		meta: {
			title: 'Categories statistics'
		}
	},
	{
		name: 'project-statistics-copy',
		path: '/project-statistics-copy',
		component: ProjectStatistics2,
		meta: {
			title: 'Project statistics'
		}
	}
]
